<template>
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="message">
        <h1 class="title">{{ alternateEnding.alternateEndingHeader }}</h1>
        <div class="message-body">
          <span v-html="alternateEnding.alternateEndingMessage"></span>
        </div>
        <div
          class="next-steps-button"
          v-if="
            alternateEnding.alternateEndingButtonLabel &&
              alternateEnding.alternateEndingButtonUrl
          "
        >
          <a
            class="button is-primary submit-button"
            target="_blank"
            :href="alternateEnding.alternateEndingButtonUrl"
            >{{ alternateEnding.alternateEndingButtonLabel }}</a
          >
        </div>

        <div
          v-if="this.alternateEnding.alternateEndingShowOndemandSessionButton"
        >
          <span v-html="alternateEnding.alternateEndingOnDemandMessage"></span>
          <OnDemandButton
            :buttonText="alternateEnding.alternateEndingOnDemandButtonText"
            :organizationLocationId="organizationLocationId"
          />
        </div>
      </div>
      <contact></contact>
      <reset-button></reset-button>
    </div>
  </div>
</template>

<script>
import contact from "@/components/Contact";
import resetButton from "../questions/resetButton";
import { sendInterviewCompleted } from "../../helpers/iframe";
import OnDemandButton from "../questions/OnDemandButton";

export default {
  name: "AlternateEnding",

  components: {
    contact,
    resetButton,
    OnDemandButton
  },
  computed: {
    alternateEnding() {
      let endings = this.$store.getters["interview/getAlternateEndings"];
      let ending = endings[this.$store.getters["interview/getAlternateEnding"]];
      return ending;
    }
  },
  mounted() {
    sendInterviewCompleted();
  }
};
</script>

<style lang="scss" scoped>
.next-steps-button {
  width: initial;
  display: inline-block;
}
</style>
